import styled from '@emotion/styled';
import {mixinHeading} from 'webapp-lib/styling';

export interface Props {
  noImage?: boolean;
}

export const StyledPlaceholder = styled('div', {
  shouldForwardProp: (prop) => prop !== 'noImage',
})<Props>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: ${({noImage}): string => (noImage ? 'flex-start' : 'center')};
  ${({noImage}): string =>
    noImage ? 'padding-bottom: var(--gutter-little);' : ''};

  hr {
    width: 600px;
    border-top: 3px solid var(--color-core-primary);
    margin-top: -2px;
  }

  > svg {
    height: 288px;
    fill: var(--color-state-active);
  }
`;

export const StyledHeader = styled.h2`
  ${mixinHeading}
  text-align: center;
  margin-top: 48px;
`;

export const StyledDescription = styled.p`
  font-size: var(--font-size-default);
  font-weight: var(--font-weight-thin);
  text-align: center;
  margin: var(--gutter-medium);
`;
